import { QuoteDeclarationSearchRequestQuery } from '@lio/api-types';

export const getQuoteDeclarationQuery = (params: QuoteDeclarationSearchRequestQuery) => {
  const { sort, declarationType, pageLimit, pageOffset } = params;
  const query = new URLSearchParams();

  if (sort) {
    query.append('sort', sort);
  }

  if (declarationType) {
    query.append('declarationType', declarationType);
  }

  query.append('pageLimit', pageLimit?.toString() ?? '10');

  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }

  return query.toString();
};
